import { useState, useEffect } from "react";
import API from "../api";
import Select from "react-select";

function CreateOrderModal({ onClose, refreshOrders, refreshInventory }) {
  const today = new Date().toISOString().split("T")[0];

  const [customerId, setCustomerId] = useState("");
  const [orderDate, setOrderDate] = useState(today);
  const [remark, setRemark] = useState("");

  const [sheets, setSheets] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [strips, setStrips] = useState([]);

  const [sheetId, setSheetId] = useState("");
  const [quantity, setQuantity] = useState("1");
  const [selectedStrips, setSelectedStrips] = useState([]);
  const [isReplacement, setIsReplacement] = useState(false);

  const [items, setItems] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    API.get("inventory/get-inventory/").then(res => setSheets(res.data));
    API.get("inventory/strip-list/").then(res => setStrips(res.data));
    API.get("order/get-customers/").then(res => setCustomers(res.data));
  }, []);

  const addItem = () => {
    if (!sheetId || !quantity || selectedStrips.length === 0) return;

    const sheet = sheets.find(s => s.id == sheetId);

    const existingIndex = items.findIndex(
      item => item.sheet_id == sheetId
    );

    if (existingIndex !== -1) {
      const updated = [...items];
      updated[existingIndex].quantity_sheets =
        parseInt(updated[existingIndex].quantity_sheets) +
        parseInt(quantity);

      const mergedStrips = [
        ...new Set([
          ...updated[existingIndex].strip_ids,
          ...selectedStrips
        ])
      ];

      updated[existingIndex].strip_ids = mergedStrips;
      updated[existingIndex].strips_display = strips
        .filter(s => mergedStrips.includes(s.id))
        .map(s => s.size_mm);

      updated[existingIndex].is_replacement =
        updated[existingIndex].is_replacement || isReplacement;

      setItems(updated);
    } else {
      setItems([
        ...items,
        {
          sheet_id: sheetId,
          sheet_name: sheet.name,
          quantity_sheets: quantity,
          strip_ids: selectedStrips,
          strips_display: strips
            .filter(s => selectedStrips.includes(s.id))
            .map(s => s.size_mm),
          is_replacement: isReplacement
        }
      ]);
    }

    setSheetId("");
    setQuantity("1");
    setSelectedStrips([]);
    setIsReplacement(false);
  };

  const deleteRow = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const totalSheets = items.reduce(
    (total, item) => total + parseInt(item.quantity_sheets || 0),
    0
  );

  const saveOrder = async () => {
  let newErrors = {};

  let finalItems = [...items];

  // Check if input row has valid data
  const hasPendingRow =
    sheetId &&
    quantity &&
    selectedStrips.length > 0;

  if (hasPendingRow) {
    const existingIndex = finalItems.findIndex(
      item => item.sheet_id == sheetId
    );

    if (existingIndex !== -1) {
      // Merge with existing row
      finalItems[existingIndex].quantity_sheets =
        parseInt(finalItems[existingIndex].quantity_sheets) +
        parseInt(quantity);

      const mergedStrips = [
        ...new Set([
          ...finalItems[existingIndex].strip_ids,
          ...selectedStrips
        ])
      ];

      finalItems[existingIndex].strip_ids = mergedStrips;
      finalItems[existingIndex].is_replacement =
        finalItems[existingIndex].is_replacement || isReplacement;

    } else {
      // Add as new row
      finalItems.push({
        sheet_id: sheetId,
        sheet_name: sheets.find(s => s.id == sheetId)?.name,
        quantity_sheets: quantity,
        strip_ids: selectedStrips,
        is_replacement: isReplacement
      });
    }
  }

  if (!customerId) newErrors.customer = "Customer is required";
  if (!orderDate) newErrors.date = "Order date is required";
  if (finalItems.length === 0)
    newErrors.items = "Add at least one item";

  setErrors(newErrors);
  if (Object.keys(newErrors).length > 0) return;

  await API.post("order/create-order/", {
    customer_id: customerId,
    order_date: orderDate,
    remark,
    items: finalItems.map(i => ({
      sheet_id: i.sheet_id,
      quantity_sheets: i.quantity_sheets,
      strip_ids: i.strip_ids,
      is_replacement: i.is_replacement
    }))
  });

  refreshOrders();
  refreshInventory();
  onClose();
};

const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "30px",
    fontSize: "12px",
    borderRadius: "0.25rem"
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px"
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "30px"
  }),
  menu: (base) => ({
    ...base,
    fontSize: "12px"
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  })
};

  return (
    <>
     <div className="modal-backdrop fade show"></div>
    <div className="modal fade show d-block" tabIndex="-1"> 
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">

          {/* HEADER */}
          <div className="modal-header py-2">
            <h6 className="modal-title">New Order Entry</h6>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          {/* BODY */}
          <div className="modal-body py-2">

            {/* Top Row */}
            <div className="row g-2 mb-2">
              <div className="col-md-4">
                <Select
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={selectStyles}
                  options={customers.map(c => ({
                    value: c.id,
                    label: c.name
                  }))}
                  value={
                    customers
                      .filter(c => c.id == customerId)
                      .map(c => ({
                        value: c.id,
                        label: c.name
                      }))[0] || null
                  }
                  onChange={(selected) =>
                    setCustomerId(selected ? selected.value : "")
                  }
                  placeholder="Customer"
                />
                {errors.customer && (
                  <small className="text-danger">
                    {errors.customer}
                  </small>
                )}
              </div>

              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={orderDate}
                  onChange={e => setOrderDate(e.target.value)}
                />
              </div>

              <div className="col-md-5">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Remark"
                  value={remark}
                  onChange={e => setRemark(e.target.value)}
                />
              </div>
            </div>

            {/* Excel Grid */}
            <div className="border rounded" style={{ maxHeight: "320px", overflowY: "auto" }}>
              <table
                className="table table-sm table-bordered mb-0 align-middle"
                style={{
                  borderCollapse: "collapse",
                  fontSize: "12px",
                  tableLayout: "fixed"
                }}
              >
                <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <tr>
                    <th className="px-2 py-1">Sheet</th>
                    <th className="px-2 py-1 text-center" style={{ width: "78px" }}>Qty</th>
                    <th className="px-2 py-1">Strips</th>
                    <th className="px-2 py-1 text-center" style={{ width: "98px" }}>Replacement</th>
                    <th className="px-2 py-1 text-center" style={{ width: "52px" }}>X</th>
                  </tr>
                </thead>

                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td className="px-2 py-1">
                        {item.sheet_name}
                      </td>

                      <td className="px-2 py-1">
                        <input
                          type="number"
                          className="form-control form-control-sm border-0 px-1 py-0"
                          value={item.quantity_sheets}
                          onChange={(e) => {
                            const updated = [...items];
                            updated[index].quantity_sheets = e.target.value;
                            setItems(updated);
                          }}
                        />
                      </td>

                      <td className="px-2 py-1 text-truncate">
                        {item.strips_display.join(", ")}
                      </td>

                      <td className="px-2 py-1 text-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={item.is_replacement}
                          onChange={(e) => {
                            const updated = [...items];
                            updated[index].is_replacement = e.target.checked;
                            setItems(updated);
                          }}
                        />
                      </td>

                      <td className="px-1 py-1 text-center">
                        <button
                          className="btn btn-sm btn-outline-danger py-0 px-1"
                          onClick={() => deleteRow(index)}
                        >
                          ✕
                        </button>
                      </td>
                    </tr>
                  ))}

                  {/* Input Row */}
                  <tr className="table-light">
                    <td className="px-1 py-1">
                      <Select
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                        options={sheets.map(sheet => ({
                          value: sheet.id,
                          label: sheet.name
                        }))}
                        value={
                          sheets
                            .filter(s => s.id == sheetId)
                            .map(s => ({
                              value: s.id,
                              label: s.name
                            }))[0] || null
                        }
                        onChange={(selected) =>
                          setSheetId(selected ? selected.value : "")
                        }
                        placeholder="Select..."
                        styles={selectStyles}
                      />
                    </td>

                    <td className="px-2 py-1">
                      <input
                        type="number"
                        className="form-control form-control-sm border-0 px-1 py-0"
                        value={quantity}
                        onChange={e => setQuantity(e.target.value)}
                      />
                    </td>

                    <td className="px-1 py-1">
                      <Select
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={selectStyles}
                        isMulti
                        options={strips.map(strip => ({
                          value: strip.id,
                          label: strip.size_mm
                        }))}
                        value={strips
                          .filter(s => selectedStrips.includes(s.id))
                          .map(s => ({
                            value: s.id,
                            label: s.size_mm
                          }))
                        }
                        onChange={(selected) =>
                          setSelectedStrips(
                            selected ? selected.map(s => s.value) : []
                          )
                        }
                        placeholder="Select..."
                      />
                    </td>

                    <td className="px-2 py-1 text-center">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isReplacement}
                        onChange={(e) =>
                          setIsReplacement(e.target.checked)
                        }
                      />
                    </td>

                    <td className="px-1 py-1 text-center">
                      <button
                        className="btn btn-sm btn-success py-0 px-2"
                        onClick={addItem}
                      >
                        +
                      </button>
                    </td>
                  </tr>

                  {/* Total Row */}
                  {items.length > 0 && (
                    <tr className="table-secondary fw-semibold">
                      <td className="px-2 py-1">
                        Total
                      </td>
                      <td className="px-2 py-1 text-center">
                        {totalSheets}
                      </td>
                      <td colSpan="3" className="px-2 py-1" />
                    </tr>
                  )}

                </tbody>
              </table>
            </div>

            {errors.items && (
              <div className="text-danger mt-2">
                {errors.items}
              </div>
            )}

          </div>

          {/* FOOTER */}
          <div className="modal-footer py-2">
            <button className="btn btn-sm btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-sm btn-primary" onClick={saveOrder}>
              Save Order
            </button>
          </div>

        </div>
      </div>
    </div>
    </>
  );
}

export default CreateOrderModal;